// A verified credential's reviewed details change only through the verifier
// who verified it, for the verification fee (docs/EDIT_POLICY.md). The
// description and the share toggle are saved directly.
const REVIEWED_FIELDS = [
  "title",
  "issuer",
  "startDate",
  "endDate",
  "isCurrent",
  "metadata",
  "certificateS3Key",
  "certificateFileName",
];

/** The reviewed fields of a credential form's payload. */
export function reviewedFields(payload) {
  return Object.fromEntries(
    Object.entries(payload).filter(([field]) =>
      REVIEWED_FIELDS.includes(field),
    ),
  );
}

/** Whether a change can be sent: verified, with nothing waiting. */
export function canRequestChange(credential) {
  return (
    credential?.status === "VERIFIED" &&
    !(credential.verificationRequests ?? []).some(
      (request) => request.status === "PENDING",
    )
  );
}

/** The change waiting for the verifier (an EDIT request), or null. */
export function pendingEdit(credential) {
  return (
    (credential?.verificationRequests ?? []).find(
      (request) => request.status === "PENDING" && request.context === "EDIT",
    ) ?? null
  );
}
